import React, {Component} from 'react';
import CSVUploader from "alpaca.js/dist/bulk_upload/csvUploader";
import axios from "axios/index";

const COLUMN_MAPPINGS = {
    examination_resolution_id: "Auth Number",
    invoice_number: "Invoice Number",
    requested_amount: "Amount",
};

export default class InvoiceUpload extends Component {
    render() {
        return  (
            <div className="container">
                <CSVUploader
                    mappings={this.props.mappings}
                    data={this.props.data}
                    columns={COLUMN_MAPPINGS}
                    uploadUrl="/api/invoices/bulk/"
                    axiosInstance={axios}
                    onUpload={() => {document.location = '/invoices/upload/errors/'}}
                />
            </div>
        )
    }
}
